export default __webpack_public_path__ + "static/media/cp_geo_ae.bcbbb2cb.svg";